// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"53":"eiendom","25522":"ui","62590":"sbanken","79351":"commons"}[chunkId] + "." + {"53":"ffe85b92a495100da537","25522":"2c5804bfc6186ac680e7","62590":"cac21ab2abf2bb44621c","79351":"a4981b7d96596ac73054"}[chunkId] + ".css";
};